import DeleteConfirmationDialog from '@components/DeleteConfirmation';
import { useAssignUnAssignTagInTranscript } from '@hooks/postQueries';
import useConfirmationDialog from '@hooks/useDeleteConfirmation';
import { Icon } from '@iconify/react';
import { IconButton, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { formatInTitleCase } from '@utils/constants';
import { useCallback, useState } from 'react';

function AssignedTagInTranscript({ transcriptDetail, canEdit }) {
  const [hoveredTag, setHoveredTag] = useState(null);
  const [hoveredTagValue, setHoveredTagValue] = useState(null);
  const [unAssignType, setUnAssignType] = useState('Tag');
  const { open, show, handleConfirm, handleClose } = useConfirmationDialog();
  const { mutateAsync, isPending } = useAssignUnAssignTagInTranscript('unassign');

  const handleRemoveItem = useCallback(
    (tagPayload) => {
      show(async () => {
        const payload = {
          tags: tagPayload,
          isAssignTag: false,
        };

        let finalPayload = {
          payload,
          transcriptId: transcriptDetail?.id,
          studyId: transcriptDetail?.study_id,
        };

        mutateAsync(finalPayload);
      });
    },
    [mutateAsync, show],
  );

  return (
    <Box display={'flex'} gap={1.5} flexWrap={'wrap'} alignItems={'center'} mb={2}>
      {transcriptDetail?.assigned_tags.map((tag) => (
        <Box
          onMouseEnter={() => setHoveredTag(tag)}
          onMouseLeave={() => setHoveredTag(null)}
          key={tag.tag_key_id}
          sx={{
            backgroundColor: '#f3e7ff',
            padding: '4px 10px',
            borderRadius: '24px',
            display: 'flex',
            gap: 1,
            alignItems: 'center',
          }}
        >
          <strong>{formatInTitleCase(tag.tag_key)} : </strong>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            {tag.values.map((value) => (
              <Typography
                onMouseEnter={() => setHoveredTagValue(value)}
                onMouseLeave={() => setHoveredTagValue(null)}
                key={value.tag_value_id}
                sx={{
                  background: 'white',
                  borderRadius: '24px',
                  padding: '0px 5px',
                  fontSize: '13px',
                }}
              >
                {formatInTitleCase(value.value_key)}
                {canEdit && hoveredTagValue?.tag_value_id === value.tag_value_id && (
                  <IconButton
                    className="deleteIcon"
                    aria-label={`edit`}
                    onClick={() => {
                      setUnAssignType('Value');
                      handleRemoveItem([
                        {
                          tag_key_id: tag.tag_key_id,
                          tag_value_id: value.tag_value_id,
                        },
                      ]);
                    }}
                    sx={{
                      p: 0.25,
                    }}
                  >
                    <Icon
                      icon="streamline:delete-1-solid"
                      width="11"
                      height="11"
                      style={{ marginLeft: '5px' }}
                    />
                  </IconButton>
                )}
              </Typography>
            ))}
          </Box>
          {canEdit && !hoveredTagValue && hoveredTag?.tag_key_id === tag.tag_key_id && (
            <IconButton
              className="deleteIcon"
              aria-label={`edit`}
              onClick={() => {
                setUnAssignType('Tag');
                let tempTag = tag.values.map((value) => ({
                  tag_key_id: tag.tag_key_id,
                  tag_value_id: value.tag_value_id,
                }));
                handleRemoveItem(tempTag);
              }}
              sx={{
                p: 0.25,
              }}
            >
              <Icon icon="streamline:delete-1-solid" width="12" height="12" />
            </IconButton>
          )}
        </Box>
      ))}

      <DeleteConfirmationDialog
        open={open}
        onClose={handleClose}
        onConfirm={handleConfirm}
        title="Unassign Tag"
        isPending={isPending}
        content={`This action cannot be undone. Are you sure want to unassign ${unAssignType === 'Tag' ? 'this Tag ?' : "this Tag's value ?"}`}
        okText={
          isPending ? 'Unassigning' : unAssignType === 'Tag' ? 'Unassign Tag' : 'Unassign Tag Value'
        }
      />
    </Box>
  );
}

export default AssignedTagInTranscript;
